import { useMemo } from 'react'
import { ROUTES } from 'constants/routes'

const useGetConnectionLink = (networkType) =>
  useMemo(() => {
    switch (networkType) {
      case 'sape':
        return ROUTES.BILLING_DEPOSIT
      default:
        return ROUTES.SERVICES_NETWORK_ACCOUNT_REGISTER
    }
  }, [networkType])

export { useGetConnectionLink as useGetConnectionLink }
